import { useLocale } from '@spotify-internal/i18n-core';

export function useNumberFormatter(options: Intl.NumberFormatOptions = {}) {
  const locale = useLocale();
  return new Intl.NumberFormat(locale, options);
}
